import { AsyncActionHandler } from 'action-handler';

export default new AsyncActionHandler({
  name: 'set_app_id',
  stateProp: 'app',
  defaultState: {
    apps: {}
  },
  handler(id) {
    return async () => ({
      id
    });
  },
  reduce(state, { id }) {
    if (!id) {
      return state;
    }

    return {
      [this.stateProp]: {
        entry: id
      }
    };
  }
});
